__turbopack_context__.v({
  "body": "_7hiC8W_body",
  "body--inverse": "_7hiC8W_body--inverse",
  "body--statement": "_7hiC8W_body--statement",
  "title": "_7hiC8W_title",
  "title--compact": "_7hiC8W_title--compact",
  "title--display": "_7hiC8W_title--display",
  "title--feature": "_7hiC8W_title--feature",
  "title--floating": "_7hiC8W_title--floating",
  "title--inverse": "_7hiC8W_title--inverse",
  "title--loose": "_7hiC8W_title--loose",
  "title--size-feature": "_7hiC8W_title--size-feature",
});
